import React from 'react';
import SettingsGridWrapper from '../../../../../components/Dashboard/settings/ui/SettingsGridWrapper';
import SettingsSectionHeader from '../../../../../components/Dashboard/settings/ui/SettingsSectionHeader';
import SettingsMainContentWrapper from '../../../../../components/Dashboard/settings/ui/SettingsMainContentWrapper';
import DashboardSubheader from '../../../../../components/Dashboard/DashboardSubheader';
import SignOutCard from '../../../../../components/Dashboard/settings/account-actions/SignOutCard';

export default function AccountActionsPage() {
  return (
    <SettingsGridWrapper>
      <SettingsSectionHeader
        header="Account Actions"
        subheader="Manage your account preferences and security settings."
      />
      <SettingsMainContentWrapper className="space-y-4">
        <DashboardSubheader>Required Documents</DashboardSubheader>
        <SignOutCard />
        {/* <DeleteAccountCard /> */}
      </SettingsMainContentWrapper>
    </SettingsGridWrapper>
  );
}
